import { Flex, Text } from "@mantine/core";

import SvgUploadFile from "../../components/Icons/UploadFile.tsx";

export const UploadDocumentMessage = () => {
  return (
    <Flex
      direction="column"
      align="center"
      h="100%"
      justify="center"
      gap={16}
      pt={16}
    >
      <SvgUploadFile width={80} height={80} />
      <Text>Upload document to process it</Text>
    </Flex>
  );
};
